'use client';

import type { FC, IframeHTMLAttributes } from 'react';

type Props = Omit<IframeHTMLAttributes<HTMLIFrameElement>, 'src' | 'title'> & {
  src: string;
  title: string;
};

/**
 * XiCafe captive portal iframe.
 *
 * `src` is the captive-portal URL (with the `?token=` auto-login param). The
 * iframe is otherwise passive; the portal owns its UI.
 *
 * `title` is required for assistive tech; the caller owns the translated label
 * so this component stays string-free.
 */
export const XiCafePortalIframe: FC<Props> = ({
  src,
  title,
  ...iframeProps
}) => <iframe src={src} title={title} {...iframeProps} />;
